import React, { useEffect, useState } from "react";
import PendingApprovalsTable from "./PendingApprovalsTable";
import PendingApprovals from "./PendingApprovals";
import StatusDistribution from "./StatusDistribution";
import RecentActivity from "./RecentActivity";
import Approved from "./Approved";
import Rejected from "./Rejected";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import translations from "../../translation"; // Assuming a translations file exists
import Layout from "../../layout/Layout";
const Dashboard = ({language}) => {
  const [cardsData, setCardsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const formData = new FormData();
      formData.append("approval_id", user.id);
      const response = await fetch(
        `${process.env.REACT_APP_CHECK_USER_API}/api/approval/count`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        toastr.error(translations[language].apiFetchError || "Failed to fetch data from the API");
        return;
      }

      const data = await response.json();
      setCardsData(data.data || {});
    } catch (error) {
      console.error("Error fetching data: ", error);
      toastr.error(translations[language].apiError || "An error occurred while fetching data");
    } finally {
      setIsLoading(false); // End loading
    }
  };

  const translate = (key) => translations[language][key] || key;

  return (
    <Layout title={"Dashboard"}>
    <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
      {/* Top Section: Cards */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-8">
        <PendingApprovals content={cardsData?.pending || 0} language={language} />
        <Approved content={cardsData?.approved || 0} language={language} />
        <Rejected content={cardsData?.rejected || 0} language={language} />
      </div>

      {/* Bottom Section: Tables and Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <h2 className="text-lg font-bold mb-4">
            {translate("pendingApprovalsTableTitle") || "Pending Approvals"}
          </h2>
          <PendingApprovalsTable language={language} />
        </div>
        <div className="lg:col-span-1">
          <h2 className="text-lg font-bold mb-4">
            {translate("statusDistributionTitle") || "Status Distribution"}
          </h2>
          {cardsData && <StatusDistribution content={cardsData} language={language} />}
          <h2 className="text-lg font-bold mt-6">
            {translate("recentActivityTitle") || "Recent Activity"}
          </h2>
          <RecentActivity language={language} />
        </div>
      </div>
    </main>
    </Layout>
  );
};

export default Dashboard;
